const retailDt           = require('./retail-dt')
const retailFullcont     = require('./retail-fullcont')
const retailMenu         = require('./retail-menu')
const retailMT           = require('./retail-fullcont-multitable')
const retailPage         = require('./retail-page')
const retailKey          = require('./retail-key')

export function start(detail) {
      obj[detail.elem].start(detail)
}

const obj = {
      dt:           { start: (detail) => { retailDt.start(detail)           } },
      fullcont:     { start: (detail) => { retailFullcont.start(detail)     } },
      multitable:   { start: (detail) => { retailMT.start(detail)           } },
      menu:         { start: (detail) => { retailMenu.start(detail)         } },
      page:         { start: (detail) => { retailPage.start(detail)         } },
      key:          { start: (detail) => { retailKey.start(detail)          } },
}
